import React from 'react'
import styled, { keyframes } from 'styled-components'

const SKELETON_ROW_COUNT = 8

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`

const Bar = styled.div`
  background: linear-gradient(90deg, #eceff1 0%, #f5f7f8 50%, #eceff1 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s linear infinite;
  border-radius: 4px;
`

const TitleBar = styled(Bar)`
  height: 12px;
  width: 60%;
`

const MessageBar = styled(Bar)`
  height: 10px;
  width: 85%;
  margin-top: 8px;
`

const TimestampBar = styled(Bar)`
  height: 9px;
  width: 35%;
  margin-top: 8px;
`

const Dot = styled(Bar)`
  width: 10px;
  height: 10px;
  border-radius: 50%;
`

const SkeletonRow = () => (
  <div className="pt-4 pr-4 pb-4 d-flex align-items-center border-bottom">
    <div className="pl-2 pr-3">
      <Dot/>
    </div>
    <div className="w-100 pr-4">
      <TitleBar/>
      <MessageBar/>
      <TimestampBar/>
    </div>
  </div>
)

export const Loading = () => (
  <div className="w-100">
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, i) => <SkeletonRow key={i}/>)}
  </div>
)
